import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { CardReference } from "./CardReference";

export const References = ({ references = [] }) => {
  if (!references?.length) return null;

  return (
    <Box>
      <Typography variant="h5" fontWeight={600}>
        References
      </Typography>
      <Grid container spacing={2} mt={0}>
        {references.map((item) => (
          <Grid item xs={12} sm={6} key={item.id}>
            <CardReference reference={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
